import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStore } from "../Store";

const CallButtonModel = ({ noEvent = false }: { noEvent?: boolean }) => {
  const { t } = useTranslation();
  const { casesStore } = useStore();
  const presentation = casesStore.presentation;
  const statusPhone = (noEvent ? presentation?.noEventContactPhone : presentation?.contactPhone)?.trim();
  const supportPhone = presentation?.contactPagePhone.trim();
  const phone = statusPhone || supportPhone;
  if (!presentation || !phone) return null;

  const brand = presentation.brand;
  const text = !statusPhone || (noEvent && statusPhone === supportPhone) ? "ContactPageHeader1" :
    brand === "kia" ? "ContactText3" :
    brand === "volvia" || brand === "volvia-commercial" ? "ContactText2" :
    "ContactText";
  const label = t(text);
  if (!label.trim()) return null;

  return (
    <div className={`info-container-contact-info-call-button p-${brand}`}>
      <div className={`phone-logo-first ${brand === "hedin" || brand === "hongqi" ? "" : "white"}`} />
      <a className={`info-container-contact-info-call-button-main-${brand}`}
        href={`tel:${phone.replace(/\s/g, "")}`}>
        {label}
      </a>
    </div>
  );
};

export default observer(CallButtonModel);
